<template>
  <div>
    <Topnav />
    <div class="content">
      <div class="jumbotron text-center">
        <h2>Refund Policy</h2>
        <hr class="bg-dark"/>
      </div>
      <div class="container mb-5">
        <div class="row">
          <div class="col-md-2"></div>
          <div class="col-xs-12 col-md-8">

            <h4>Refunds</h4>
            <p>Please read the subscription terms and conditions carefully before subscribing to any of the subscription plans, as once you have subscribed you cannot change, cancel your subscription plan. Once you subscribe and make the required payment, it shall be final and there cannot be any changes or modifications to the same and neither will there be any refund.</p>
            
          </div>
          <div class="col-md-2"></div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<style media="screen">
p,
li {
  color: #000;
}
</style>

<script type="text/javascript">
import Topnav from "@/components/Topnav.vue";


export default {
  name: "RefundPolicy",
  components: {
    Topnav,
    
  },
  data: function() {
    return {
      comapanyMail: "thebotcreator20@gmail.com",
      companyAddress: "GRS software solutions, halagi, haveri, 581213"
    };
  },
  methods: {
    
  }
};
</script>
